export const ENCODING = Object.freeze({
  ASCII: 'ascii',
  BASE64: 'base64',
  BINARY: 'binary',
  HEX: 'hex',
  LATIN1: 'latin1',
  UTF8: 'utf8',
  UTF_8: 'utf-8',
  UCS2: 'ucs2',
  UCS_2: 'ucs-2',
  UTF16LE: 'utf16le',
  UTF_16LE: 'utf-16le',
});

export const FILE_EXTENSION = Object.freeze({
  JSON: 'json',
  JS: 'js',
  COFFEE: 'coffee',
  HTML: 'html',
  TXT: 'txt',
  CSV: 'csv',
  PNG: 'png',
  JPG: 'jpg',
  JPEG: 'jpeg',
  GIF: 'gif',
  TIF: 'tif',
  TIFF: 'tiff',
  ZIP: 'zip',
  PDF: 'pdf',
  VCF: 'vcf',
  SVG: 'svg',
  XLS: 'xls',
  XLSX: 'xlsx',
  DOC: 'doc',
  DOCX: 'docx',
  MP3: 'mp3',
});
